import { apiWrapper } from "apis/CommonApi";
import Pagenation from "components/Pagenation";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import * as dbmsApi from "../../apis/DbmsApi";
import {
  FireReceiverMdbFilterType,
  getFireReceiverMdbFilterTypeName,
} from "utils/common";
import { dateFormat, getDateTime } from "utils/date";
import { API_HOST } from "Constants";

//화재수신기 MDB
export default function FireReceiverMdbComponent() {
  const itemsPerPage = 100;
  const [isDelModalOpen, setIsDelModalOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSearchListOpen, setIsSearchListOpen] = useState(false);
  const [selectedSearchType, setSelectedSearchType] = useState("1");
  const [searchText, setSearchText] = useState("");
  const [dataSource, setDataSource] = useState([]);
  const [previous, setPrevious] = useState(null);
  const [next, setNext] = useState(null);
  const [page, setPage] = useState(1);
  const [checkedIds, setCheckedIds] = useState([]);
  const [uploadFile, setUploadFile] = useState(null);
  const [uploadFilename, setUploadFilename] = useState("");
  const [isCheckedValid, setIsCheckedValid] = useState(false);
  const [validResult, setValidResult] = useState(null);

  useEffect(() => {
    getData(1);
  }, []);

  //page: 1베이스
  const getData = (page, url = null) => {
    apiWrapper(async () => {
      let result;
      if (url !== null) {
        result = await dbmsApi.getFireReceiverMdbListByUrl(url);
      } else {
        result = await dbmsApi.getFireReceiverMdbList(
          searchText,
          selectedSearchType,
          page,
          itemsPerPage
        );
      }

      const { status, data } = result;
      if (status === true) {
        setDataSource(data);

        setPrevious(data.previous);
        setNext(data.next);
        setPage(page);
      } else {
        alert(`${data}`);
      }
    });
  };

  const handleCheckAll = (e) => {
    if (e.target.checked) {
      setCheckedIds(dataSource.results.map((a) => a.id));
    } else {
      setCheckedIds([]);
    }
  };

  const handleChangeCheck = (e, id) => {
    if (e.target.checked) {
      setCheckedIds([...checkedIds, id]);
    } else {
      setCheckedIds(checkedIds.filter((a) => a !== id));
    }
  };

  const toggleSelectBox = () => {
    setIsSearchListOpen(!isSearchListOpen);
  };

  const handleSearchItemClick = (type) => {
    setSelectedSearchType(type);
    setIsSearchListOpen(false);
  };

  const handleChangeSearchText = (e) => {
    setSearchText(e.target.value);
  };

  const handleSearch = (e) => {
    if (e.type === "click" || (e.type === "keydown" && e.keyCode === 13)) {
      getData(page);
    }
  };

  const openModal = () => {
    setIsModalOpen(true);
    setTimeout(() => {
      const modalContent = document.querySelector(".modal_content");
      if (modalContent) {
        modalContent.style.transform = "translateX(0)";
      }
    }, 10);
  };

  const closeModal = () => {
    //초기화
    setUploadFile(null);
    setUploadFilename("");
    setIsCheckedValid(false);
    setValidResult(null);

    const modalContent = document.querySelector(".modal_content");
    if (modalContent) {
      modalContent.style.transform = "translateX(100%)";
    }
    setTimeout(() => {
      setIsModalOpen(false);
    }, 500);
  };

  const handleCheckValid = (e) => {
    e.preventDefault();

    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
    } else if (checkValid() === false) {
      e.stopPropagation();
    } else {
      apiWrapper(async () => {
        const requestBody = new FormData();
        requestBody.append("file", uploadFile);
        const { status, data } = await dbmsApi.validateExcelFireReceiverMdb(
          requestBody
        );
        if (status === true) {
          //성공 시 등록 화면으로
          setIsCheckedValid(true);
          setValidResult({
            validCount: data.validCount,
            errorCount: data.errorCount,
          });
        }
      });
    }
  };

  const handleSave = (e) => {
    e.preventDefault();

    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
    } else if (checkValid() === false) {
      e.stopPropagation();
    } else {
      apiWrapper(async () => {
        const requestBody = new FormData();
        requestBody.append("file", uploadFile);
        const { status, data } = await dbmsApi.uploadExcelFireReceiverMdb(
          requestBody
        );
        if (status === true) {
          alert("등록을 완료하였습니다.");

          //성공 시 새로고침
          closeModal();
          getData(page);
        }
      });
    }
  };

  const checkValid = () => {
    if (uploadFile === null) {
      alert("파일을 선택해주세요.");
      return false;
    }
    return true;
  };

  const onChange = (e) => {
    if (e.target.type === "file") {
      const newFiles = e.target.files;
      if (newFiles.length > 0) {
        setUploadFile(newFiles[0]);
        setUploadFilename(newFiles[0].name);
      }
    }
  };

  const handlePageArrowClick = (page, isNext) => {
    let url = null;
    if (isNext === false) {
      url = previous;
    } else {
      url = next;
    }

    getData(page, url);
  };

  const handleDelete = () => {
    apiWrapper(async () => {
      const { status, data } = await dbmsApi.bulkDeleteFireReceiverMdb(
        checkedIds
      );
      alert(`${data}`);

      //삭제 성공 시 새로고침
      if (status === true) {
        setCheckedIds([]);
        closeDelModal();
        getData(page);
      }
    });
  };

  const openDelModal = () => {
    if (checkedIds.length < 1) {
      alert("1개 이상 선택해주세요.");
    } else {
      setIsDelModalOpen(true);
    }
  };

  const closeDelModal = () => {
    setIsDelModalOpen(false);
  };

  return (
    <>
      <div class="viewBoard viewDBMSBoard FRSboard">
        <div class="top_board pc">
          <p class="title_board">화재수신기 MDB</p>
          <div class="wrap_search openSearch">
            <div class="box_search">
              <div className={`select_box ${isSearchListOpen ? "open" : ""}`}>
                <button class="btn_select" onClick={toggleSelectBox}>
                  <p>{getFireReceiverMdbFilterTypeName(selectedSearchType)}</p>
                  <i class="x-icon"></i>
                </button>
                <ul class="list_member">
                  {Object.values(FireReceiverMdbFilterType).map(
                    (item, index) => (
                      <li onClick={() => handleSearchItemClick(item)}>
                        <p>{getFireReceiverMdbFilterTypeName(item)}</p>
                      </li>
                    )
                  )}
                </ul>
              </div>
              <input
                class=""
                type="text"
                placeholder="검색어를 입력해주세요."
                onChange={handleChangeSearchText}
                onKeyDown={handleSearch}
                defaultValue={searchText}
              />
              <button class="btn_search" onClick={handleSearch}>
                <i class="x-icon icon_search"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="top_board mb">
          <div class="wrap_logo">
            {/* <!-- <img src="" alt="" class="img_logo"> --> */}
          </div>
          <div class="header_dept">
            <p class="user">COWORKER</p>
            <div class="wrap_contr">
              <Link class="set_contr" to="">
                <img src="/images/my_btn_mb.png" alt="" />
              </Link>
            </div>
          </div>
        </div>
        <div class="top_board navi_board mb">
          <Link class="wrap_navi" to="/">
            <p class="title_navi">화재수신기 MDB</p>
          </Link>

          <div class="wrap_right mb">
            <Link class="btn_page_left" to="/dbmsMenu.html">
              <i class="x-icon"></i>
            </Link>
          </div>
        </div>

        <div class="table_board">
          <table class="admin-table uam-table">
            <colgroup>
              <col width="5%" />
              <col width="8%" />
              <col width="10%" />
              <col width="10%" />
              <col width="10%" />
              <col width="15%" />
              <col width="10%" />
              <col width="12%" />
              <col width="10%" />
              <col width="10%" />
              <col width="10%" />
              <col width="15%" />
            </colgroup>
            <thead class="admin-thead">
              <tr class="admin-tr">
                <th class="admin-th">
                  <input
                    type="checkbox"
                    name=""
                    id=""
                    onChange={handleCheckAll}
                  />
                </th>
                <th class="admin-th">관리ID</th>
                <th class="admin-th">화재수신기 모델명</th>
                <th class="admin-th">형식승인번호</th>
                <th class="admin-th">제조일련번호</th>
                <th class="admin-th">통신 DEI 번호</th>
                <th class="admin-th">제조일자</th>
                <th class="admin-th">제조업체</th>
                <th class="admin-th">로트번호</th>
                <th class="admin-th">검사합격번호</th>
                <th class="admin-th">등록자</th>
                <th class="admin-th">등록일자</th>
              </tr>
            </thead>
            <tbody class="admin-tbody">
              {dataSource.results &&
                dataSource.results.map((item, index) => (
                  <tr class="admin-tr wrap_table_item">
                    <td class="admin-td">
                      <input
                        type="checkbox"
                        name=""
                        id=""
                        checked={checkedIds.includes(item.id)}
                        onChange={(e) => handleChangeCheck(e, item.id)}
                      />
                    </td>
                    <td class="admin-td">
                      <p>{item.id}</p>
                    </td>
                    <td class="admin-td">
                      <p>{item.modelName}</p>
                    </td>
                    <td class="admin-td">
                      <p>{item.approvalNumber}</p>
                    </td>
                    <td class="admin-td">
                      <p>{item.serialNumber}</p>
                    </td>
                    <td class="admin-td">
                      <p>{item.deiNumber}</p>
                    </td>
                    <td class="admin-td">
                      <p>{item.manufactureDate}</p>
                    </td>
                    <td class="admin-td">
                      <p>{item.manufacturer}</p>
                    </td>
                    <td class="admin-td">
                      <p>{item.lotNumber}</p>
                    </td>
                    <td class="admin-td">
                      <p>{item.inspectionPassNumber}</p>
                    </td>
                    <td class="admin-td">
                      <p>{item.registrant}</p>
                    </td>
                    <td class="admin-td">
                      <p>{getDateTime(new Date(item.registeredAt))}</p>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>

        <div class="wrap_controll type-start">
          <div class="wrap_dbms_btn">
            <a
              href={
                API_HOST +
                `/media/templates/(양식) 화재수신기 MDB 등록용 양식 파일.xlsx`
              }
            >
              <button class="item_btn">양식</button>
            </a>
            <button class="item_btn" onClick={openModal}>
              추가
            </button>
            <button class="item_btn" onClick={openDelModal}>
              삭제
            </button>
          </div>
          <div id="pagination">
            <Pagenation
              totalItemsCount={dataSource.count}
              itemsPerPage={itemsPerPage}
              selectedPage={page}
              setPage={(value) => setPage(value)}
              handlePageArrowClick={handlePageArrowClick}
            />
          </div>
        </div>

        {/* <!-- 삭제 여부 모달 --> */}
        {isDelModalOpen && (
          <div id="modal" class="modal dbmsDelModal show">
            <div class="modal-content">
              <div class="modal_inner">
                <p class="modal_title">정말로 삭제하시겠습니까?</p>
                <p class="modal_sub">삭제하시면 선택하신 정보는 사라집니다.</p>
                <div class="btn-wrap">
                  <button class="modal_btn" onClick={closeDelModal}>
                    취소
                  </button>
                  <button class="modal_btn del_btn" onClick={handleDelete}>
                    삭제
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {isModalOpen && (
          <div
            id="modal"
            class="modal rightModal noticeRightModal FRSrightModal open"
            onClick={(e) => {
              if (e.target === e.currentTarget) closeModal();
            }}
          >
            {isCheckedValid === false ? (
              <form class="modal_content" onSubmit={handleCheckValid}>
                <button type="button" class="close_modal" onClick={closeModal}>
                  <i class="x-icon close_icon"></i>
                </button>
                <h2>화재수신기 MDB 추가 파일 선택</h2>
                <div class="wrap_detail_cont">
                  <div class="wrap_detail_item default_type_item">
                    <p class="title_detail">파일찾기</p>
                    <div class="detail_box detail_btn_box">
                      <div class="detail_box">
                        <input
                          class="default_input"
                          type="text"
                          placeholder="파일 경로명"
                          name="uploadFilename"
                          value={uploadFilename}
                          readOnly
                        />
                      </div>
                      <label class="black_line_btn">
                        찾기
                        <input
                          type="file"
                          accept=".xlsx"
                          name="uploadFile"
                          onChange={onChange}
                        />
                      </label>
                    </div>
                  </div>
                </div>
                <div class="wrap_btn_set">
                  <button type="submit" class="btn_dark">
                    선택
                  </button>
                </div>
              </form>
            ) : (
              <form class="modal_content" onSubmit={handleSave}>
                <button type="button" class="close_modal" onClick={closeModal}>
                  <i class="x-icon close_icon"></i>
                </button>
                <h2>화재수신기 MDB 등록 저장</h2>
                {validResult && (
                  <div class="wrap_detail_cont">
                    <div class="wrap_detail_item default_type_item">
                      <p class="title_detail">정상</p>
                      <div class="detail_box detail_btn_box">
                        <div class="detail_box">
                          <input
                            class="default_input"
                            type="text"
                            name="uploadFilename"
                            value={`${validResult.validCount}개`}
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                    <div class="wrap_detail_item default_type_item">
                      <p class="title_detail">오류</p>
                      <div class="detail_box detail_btn_box">
                        <div class="detail_box">
                          <input
                            class="default_input"
                            type="text"
                            name="uploadFilename"
                            value={`${validResult.errorCount}개`}
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                    <p class="title_detail">{`정상 ${validResult.validCount}개를 등록합니다.`}</p>
                  </div>
                )}
                <div class="wrap_btn_set">
                  <button type="submit" class="btn_dark">
                    저장
                  </button>
                </div>
              </form>
            )}
          </div>
        )}
      </div>
    </>
  );
}
